export default "__VITE_ASSET__2d2d60b0__"